import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfile } from '../../api/user';
import { setProfile } from '../../store/slices/userSlice';
import LoadingSpinner from '../../components/LoadingSpinner';
import { BRANDING } from '../../config/branding';
import {
  Field,
  FieldInput,
  FieldLabel,
  Form,
  Main,
  Message,
  Subtitle,
  SubmitButton,
  Title,
} from './styles';

const ProfileManagement = () => {
  const dispatch = useDispatch();
  const { profile, profileLoaded } = useSelector(state => state.user);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [displayName, setDisplayName] = useState(profile?.displayName || '');
  const loading = !profileLoaded;

  useEffect(() => {
    setDisplayName(profile?.displayName || '');
    setError(profileLoaded && !profile ? 'Failed to load profile.' : '');
  }, [profile, profileLoaded]);

  const save = async e => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const updated = await updateUserProfile({ displayName });
      dispatch(setProfile(updated));
      setSuccess('Profile updated successfully.');
    } catch (err) {
      setError(err.message || 'Failed to update profile.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Main>
      <Helmet>
        <title>{`${BRANDING.appName} | Profile Management`}</title>
      </Helmet>
      <Title>Profile Management</Title>
      <Subtitle>Manage your account profile information.</Subtitle>

      {loading && <LoadingSpinner label="Loading profile..." />}
      {!loading && error && <Message $error>{error}</Message>}
      {!loading && profile && (
        <Form onSubmit={save}>
          <Field>
            <FieldLabel>Email</FieldLabel>
            <FieldInput value={profile.email || ''} readOnly $readonly />
          </Field>
          <Field>
            <FieldLabel>Display Name</FieldLabel>
            <FieldInput value={displayName} onChange={e => setDisplayName(e.target.value)} />
          </Field>
          {success && <Message $success>{success}</Message>}
          {error && <Message $error>{error}</Message>}
          <SubmitButton type="submit" disabled={saving}>
            {saving ? 'Saving...' : 'Save Profile'}
          </SubmitButton>
        </Form>
      )}
    </Main>
  );
};

export default ProfileManagement;
